import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { AlertService } from 'ng-jhipster';
import { Principal } from '../../shared';
import { UtilsService } from '../../shared/utils/utils.service';
import { MasterProposal, PropositionStatus } from '../master-proposal/master-proposal.model';
import { MasterProposalService } from '../master-proposal/master-proposal.service';
import { Saisine } from './saisine.model';


@Component({
    selector: 'jhi-saisine-validation',
    templateUrl: './saisine-validation.component.html'
})
export class SaisineSchoolValidationComponent implements OnInit {
    @Input() saisine: Saisine;

    @Input() validatedBy: string;

    @Output() saisineChange = new EventEmitter();

    // Table school validation
    @ViewChild('dtSchoolValidation') dtSchoolValidation;
    multiSortMetaDtSchoolValidation: any[];
    academicRegion: string;

    specificMessageRRA1 = '';

    isSaving: boolean;
    statusFilterDtSchoolValidation: any[];

    constructor(
        private alertService: AlertService,
        public utilsService: UtilsService,
        private modalService: NgbModal,
        public principal: Principal,
        private masterProposalService: MasterProposalService) { }

    ngOnInit() {
        this.statusFilterDtSchoolValidation = [PropositionStatus.SUBMITTED];
    }

    // modal
    openAccept(content, masterProposal: MasterProposal) {
        this.modalService.open(content).result.then((result) => {
            this.isSaving = true;
            this.masterProposalService.masterProposalsAccept(this.saisine.id, masterProposal).subscribe(
                this.onSaveSuccess,
                this.onSaveError
            );
        }, (reason) => {
        });
    }

    openReject(content, saisineId, masterProposal: MasterProposal) {
        this.modalService.open(content).result.then((result) => {
            this.masterProposalService.masterProposalsReject(saisineId, masterProposal).subscribe(
                this.onSaveSuccess,
                this.onSaveError
            );
        }, (reason) => {
        });
    }

    // this binding
    onSaveSuccess = () => {
        this.isSaving = false;
        this.saisineChange.emit();
    }

    // this binding
    onSaveError = (error) => {
        this.isSaving = false;
        this.onError(error);
    }

    private onError(error) {
        this.alertService.error(error.message, null, null);
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/saisine/saisine-validation.component.ts